<template>
  <div class="ma-4">
    <StaffNav class="hideOnPrint" />
    <v-row class="hideOnPrint">
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="items.injuryDate"
                        label="Injury Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="items.injuryDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="items.claimNumber"
                    label="Claim Number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="items.accepted"
                    label="Claim Accepted by Carrier?"
                    :items="accepted"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-textarea
                    v-model="items.notes"
                    label="Notes"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <form enctype="multipart/form-data">
                    <v-file-input
                      v-model="items.physicianDocument"
                      class="pa-2"
                      label="Workers Comp"
                      filled
                      multiple
                      prepend-icon="mdi-camera"
                      accept="image/*, .pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      @change="fileSelected"
                      show-size
                    >
                      <template #selection="{ text, index }">
                        <v-chip
                          small
                          label
                          close
                          color="primary"
                          @click:close="deleteChip(index)"
                          >{{ text }}</v-chip
                        >
                      </template>
                    </v-file-input>
                  </form>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      v-for="doc in items.physicianDocument"
                      :key="doc.id"
                    >
                      <div v-if="doc.ext != 'pdf'">
                        <v-img
                          max-height="480"
                          max-width="550"
                          :src="doc.aws"
                        ></v-img>
                      </div>
                      <div v-if="doc.ext == 'pdf'">
                        <load-pdf :pdfFile="doc.aws" :pdfName="doc.name" />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="6" md="6" class="pa-2">
                  <v-text-field
                    v-model="items.physician"
                    label="Physician Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="items.physicianDate"
                        label="Date of Physician Visit"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="items.physicianDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu2 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu2.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="items.testedDate"
                        label="Date Tested"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="items.testedDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu3 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu3.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="items.results"
                    label="Results of Test"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-select
                    v-model="items.positive"
                    label="Was the Test Positive?"
                    :items="tested"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#259647"
              class="white--text"
              @click="onAddItem"
              v-if="$route.params.action === 'add' && !isAuditorRole"
              >Save</v-btn
            >
            <v-btn
              fab
              small
              @click="onPrintItem"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="$route.query.new"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              color="#2b6993"
              class="white--text"
              @click="onUpdateItem"
              v-if="$route.query.new && !isAuditorRole"
              >Update</v-btn
            >
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint" />

    <PrintItem
      :items="items"
      :staffName="staffName"
      :isPrintingItem="isPrintingItem"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StaffNav from "@/components/StaffNav";
import Foot from "@/components/Footer";
import moment from "moment";
import LoadPdf from "@/components/LoadPDF.vue";
import renameFileHelper from "@/mixins/renameFileHelper";
import PrintItem from "./print/PrintItem";
import PrintUtil from "../../../../utils/print-util";

const url = require("@/client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    StaffNav,
    Foot,
    LoadPdf,
    PrintItem,
  },
  data: function () {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      employeeID: this.$route.params.employeeID,
      staff: localStorage.getItem("Name"),
      accepted: ["Yes", "No"],
      tested: ["Yes", "No"],
      titleForm: "New Workers Comp Claim",
      claimID: "",
      isPrintingItem: false,
      items: {
        physicianDocument: [],
      },
      token: localStorage.getItem('token'),
    };
  },

  computed: {
    ...mapState("workers-comp", [
      "isLoading",
      "uploadFileItems",
      "item"
    ]),
    staffName() {
      return this.$store.state.users.user.Name;
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },
    generateDownloadUrl() {      
      return `${url}/workersComp/generate/report/${this.$route.query.id}`;
    }
  },

  created() {
    if (this.$route.query.new) {
      this.fetch();
    }
  },

  methods: {
    ...mapActions("workers-comp", [
      "getItem",
      "addItem",
      "updateItem",
      "uploadItem",
    ]),

    async fetch(){
      await this.getItem(this.$route.query.id);
      this.viewItem(this.item);
    },

    viewItem(item) {
      this.titleForm = "Viewing Claim";
      this.dialog = true;
      this.editClaim = true;
      this.newClaim = false;
      this.items.injuryDate = moment(item.InjuryDate).format("YYYY-MM-DD");
      this.items.claimNumber = item.ClaimNumber;
      this.items.accepted = item.Accepted;
      this.items.notes = item.Notes;
      // this.newWCCForm = item.WCCForm;
      this.items.physician = item.Physician;
      this.items.physicianDate = moment(item.PhysicianDate).format(
        "YYYY-MM-DD"
      );

      if (item.documents.length > 0) {
        const tempData = [];
        for (let i = 0; i < item.documents.length; i++) {
          let fileExt = item.documents[i].AWSLink.split(".").pop();
          tempData.push({
            name: item.documents[i].Name,
            id: item.documents[i]._id,
            aws: item.documents[i].AWSLink,
            ext: fileExt,
          });
        }
        this.items.physicianDocument = tempData;
      }

      this.items.testedDate = moment(item.TestedDate).format("YYYY-MM-DD");
      this.items.results = item.Results;
      this.items.positive = item.Positive;
      this.claimID = item._id;
    },

    async onUpdateItem() {
      try {
        const data = {
          InjuryDate: this.items.injuryDate,
          ClaimNumber: this.items.claimNumber,
          Accepted: this.items.accepted,
          Notes: this.items.notes,
          Physician: this.items.physician,
          PhysicianDate: this.items.physicianDate,
          TestedDate: this.items.testedDate,
          Results: this.items.results,
          Positive: this.items.positive,
        };

        const result = await this.updateItem({
          id: this.claimID,
          data,
        });

        if (result.status === 200) {
          this.$router.push({
            path: `/WorkersComp/${this.$route.params.employeeID}`,
          });
          this.saveFile();
        }
      } catch (error) {
        this.errorMsg("updating", "record", error);
      }
    },

    async onAddItem() {
      try {
        const data = {
          InjuryDate: this.items.injuryDate,
          ClaimNumber: this.items.claimNumber,
          Accepted: this.items.accepted,
          Notes: this.items.notes,
          Physician: this.items.physician,
          PhysicianDate: this.items.physicianDate,
          TestedDate: this.items.testedDate,
          Results: this.items.results,
          Positive: this.items.positive,
          EmployeeID: this.$route.params.employeeID,
        };

        const response = await this.addItem(data);

        if (response.status === 201) {
          this.$router.push({
            path: `/WorkersComp/${this.$route.params.employeeID}`,
          });

          this.claimID = response.data.results._id;
          this.saveFile();
        }
      } catch (error) {
        this.errorMsg("adding", "record", error);
      }
    },

    async fileSelected(e) {
      try {
        const files = await this.renameFileHelper(
          e,
          this.staffName,
          "WorkersComp",
          this.items.injuryDate
        );
        files.forEach((file) => this.addUploadFile(file));
      } catch (error) {
        this.errorMsg("adding", "file", error);
      }
    },

    saveFile() {
      if (this.uploadFileItems.length === 0) return;
      this.uploadFileItems.forEach((file) => {
        this.uploadItem({
          file,
          id: this.claimID,
          userId: this.$route.params.employeeID,
        });
      });
    },

    addUploadFile(file) {
      this.$store.commit("workers-comp/ADD_UPLOAD_FILE", file);
    },

    deleteChip(index) {
      this.newDocument.splice(index, 1);
    },

    close() {
      this.$router.push({
        path: `/WorkersComp/${this.employeeID}`,
      });
    },

    onPrintItem() {
      PrintUtil.showPrintOption(this.generateDownloadUrl, this.$route.query.id, this.token, 'workers-comp');
    },

    errorMsg(action, item, error) {
      console.error(`An error occured whiling ${action} ${item}`, error);
    },
  },
};
</script>
